document.addEventListener('DOMContentLoaded', function() {
  let sellingPlanInput = null;
  let priceElements = [];
  let originalPrices = new Map();
  let isInitialized = false;

  function findElements() {
    const selectors = [
      'input[name="selling_plan"]',
      'input[data-selling-plan]',
      '[data-recharge-selling-plan]',
      '.rc-widget input[type="hidden"]',
      '.recharge-widget input[type="hidden"]',
      'form input[name*="selling"]'
    ];

    for (let selector of selectors) {
      const element = document.querySelector(selector);
      if (element) {
        sellingPlanInput = element;
        break;
      }
    }

    priceElements = document.querySelectorAll('.f-price');
    return sellingPlanInput && priceElements.length > 0;
  }

  function initializePrices() {
    originalPrices.clear();
    priceElements.forEach((priceElement, index) => {
      const regularPriceSpan = priceElement.querySelector('.f-price-item--regular');
      const salePriceSpan = priceElement.querySelector('.f-price__sale .f-price-item--sale');

      if (regularPriceSpan) {
        const priceText = regularPriceSpan.textContent.trim();
        const priceValue = extractPriceValue(priceText);

        originalPrices.set(`regular-${index}`, {
          element: regularPriceSpan,
          originalText: priceText,
          originalValue: priceValue
        });
      }

      if (salePriceSpan) {
        const priceText = salePriceSpan.textContent.trim();
        const priceValue = extractPriceValue(priceText);

        originalPrices.set(`sale-${index}`, {
          element: salePriceSpan,
          originalText: priceText,
          originalValue: priceValue
        });
      }
    });
  }

  function extractPriceValue(priceText) {
    const match = priceText.match(/[\d,]+\.?\d*/);
    return match ? parseFloat(match[0].replace(',', '')) : 0;
  }

  function formatPrice(value, originalText) {
    const formattedValue = value.toFixed(2);
    return originalText.replace(/[\d,]+\.?\d*/, formattedValue);
  }

  function updatePrices(isSubscription) {
    originalPrices.forEach((priceData) => {
      if (isSubscription) {
        const discountedValue = priceData.originalValue * 0.85;
        const discountedText = formatPrice(discountedValue, priceData.originalText);
        priceData.element.textContent = discountedText;
        priceData.element.classList.add('subscription-price');
      } else {
        priceData.element.textContent = priceData.originalText;
        priceData.element.classList.remove('subscription-price');
      }
    });

    priceElements.forEach(priceElement => {
      if (isSubscription) {
        priceElement.classList.add('f-price--subscription');
      } else {
        priceElement.classList.remove('f-price--subscription');
      }
    });
  }

  function checkSellingPlan() {
    try {
      if (!sellingPlanInput) return;

      const value = sellingPlanInput.value;
      const isSubscription = value &&
                            String(value).trim() !== '' &&
                            value !== 'null' &&
                            value !== 'undefined' &&
                            value !== '0';

      updatePrices(isSubscription);
    } catch (error) {
      console.warn('Subscription price update error:', error);
    }
  }

  function setupEventListeners() {
    if (!sellingPlanInput) return;

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          checkSellingPlan();
        }
      });
    });

    observer.observe(sellingPlanInput, {
      attributes: true,
      attributeFilter: ['value']
    });

    try {
      sellingPlanInput.addEventListener('change', checkSellingPlan);
      sellingPlanInput.addEventListener('input', checkSellingPlan);
    } catch (error) {
      console.warn('Error adding event listeners:', error);
    }

    document.addEventListener('recharge:selling_plan:changed', checkSellingPlan);
    document.addEventListener('recharge:variant:changed', checkSellingPlan);

    let lastSellingPlanValue = sellingPlanInput.value;
    setInterval(function() {
      try {
        const currentValue = sellingPlanInput.value;
        if (currentValue !== lastSellingPlanValue) {
          lastSellingPlanValue = currentValue;
          checkSellingPlan();
        }
      } catch (error) {
        console.warn('Subscription price update error:', error);
      }
    }, 1000);

    checkSellingPlan();
  }

  function initialize() {
    if (isInitialized || !findElements()) return false;

    isInitialized = true;
    initializePrices();
    setupEventListeners();
    return true;
  }

  if (!initialize()) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.querySelector && (
                node.querySelector('input[name="selling_plan"]') ||
                node.matches('input[name="selling_plan"]') ||
                node.classList.contains('rc-widget') ||
                node.classList.contains('recharge-widget') ||
                node.innerHTML.includes('selling_plan')
              )) {
              setTimeout(initialize, 100);
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(initialize, 2000);
    setTimeout(initialize, 5000);
  }
});